import { render, staticRenderFns } from "./Recharge.vue?vue&type=template&id=39efa7a6&"
import script from "./Recharge.vue?vue&type=script&lang=ts&"
export * from "./Recharge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports